<template>
    <div>

        <PageHeader>
            {{ $t('productReport') }}
            <template #side>
                <div class="d-flex gap-3">
                    <ButtonResetFilters @click="resetFilters()" />
                    <TimeRangeCalendar ref="TimeRangeCalendar" v-model="timeRange" compare-year />
                </div>
            </template>
        </PageHeader>

        <SalesChart />

        <ProductReport />

        <ProductRanking />

        <SoldProducts />

    </div>
</template>



<script>
    import ButtonResetFilters from '@/components/common/ButtonResetFilters.vue';
    import TimeRangeCalendar from '@/components/common/TimeRangeCalendar.vue';
    import SalesChart from './parts/SalesChart.vue';
    import ProductReport from './parts/ProductReport.vue';
    import ProductRanking from './parts/ProductRanking.vue';
    import SoldProducts from './parts/SoldProducts.vue';

    export default {
        name: 'ReportsProducts',
        components: {
            ButtonResetFilters,
            TimeRangeCalendar,
            SalesChart,
            ProductReport,
            ProductRanking,
            SoldProducts,
        },
        provide() {
            return {
                parentComponent: this,
            };
        },
        data() {
            return {
                timeRange: null,
            };
        },
        methods: {
            resetFilters() {
                this.$emit('resetFilters');
                this.$refs.TimeRangeCalendar.resetDate();
            },
        },
    };
</script>
